import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../api/auth";
import "simplebar";
// import SimpleBar from "simplebar-react";
import formatNumber from "../../utils/formatNumber";
import { REMOVE_FROM_CART } from "../../stores/cart";
import { truncate } from "../../utils/trunate";

const Header = (prop) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const auth = useSelector((state) => state.auth.user);
  const carts = useSelector((state) => state.cart.products);

  const dispatch = useDispatch();

  const [menu, set_menu] = useState({
    explore: "",
    courses: "",
    book: "",
    category: "",
    question: "",
    virtual: "",
    academia: "",
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // //detect url change and update it.
  useEffect(() => {
    let url = window.location.hash.split("/").pop();
    Object.keys(menu).forEach(function (key) {
      set_menu((prevState) => ({
        ...prevState,
        [key]: "",
        [url]: "active",
      }));
    });
  }, [window.location.hash.split("/").pop()]);

  const subtotal = () => {
    return carts.reduce(function (result, item) {
      return result + item.ori_price * item.quantity;
    }, 0);
  };

  const onLogoutClick = (event) => {
    event.preventDefault();
    dispatch(logoutUser());
  };

  const removeItemCart = (id) => {
    dispatch(REMOVE_FROM_CART({ _id: id }));
  };

  return (
    <div>
      <header uk-sticky="border-b">
        <div className="header_inner flex items-center justify-between px-4 py-2">
          <a id="logo" href="#/">
            <img
              src="/assets/images/ed9d10d6-3fa1-4e02-8443-a34f05979d1b.png"
              alt="logo"
              style={{ height: 50 }}
            />
          </a>

          <div className="hidden md:flex flex-1 justify-center md:justify-center">
            <nav>
              <ul className="flex flex-col md:flex-row justify-center, items-center gap-1">
                <li>
                  <Link
                    to="/"
                    // to="/products"
                    className={`px-4 py-2 rounded transition ${
                      isActive("/")
                        ? "bg-blue-500 text-white"
                        : "text-gray-500 hover:bg-blue-600 hover:text-white"
                    }`}
                  >
                    STEM Kits
                  </Link>
                </li>
                <li>
                  <Link
                    to="/courses"
                    className={`px-4 py-2 rounded transition ${
                      isActive("/courses")
                        ? "bg-blue-500 text-white"
                        : "text-gray-500 hover:bg-blue-600 hover:text-white"
                    }`}
                  >
                    Courses
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/books"
                    className={`px-4 py-2 rounded transition ${
                      isActive("/books")
                        ? "bg-blue-500 text-white"
                        : "text-gray-500 hover:bg-blue-600 hover:text-white"
                    }`}
                  >
                    Books
                  </Link> */}
                {/* </li> */}
                <li>
                  <Link
                    to="/virtual"
                    className={`px-4 py-2 rounded transition ${
                      isActive("/virtual")
                        ? "bg-blue-500 text-white"
                        : "text-gray-500 hover:bg-blue-600 hover:text-white"
                    }`}
                  >
                    Virtual Lab
                  </Link>
                </li>
                {auth.isAuthenticated && (
                  <li>
                    <Link
                      to="/question"
                      className={`px-4 py-2 rounded transition ${
                        isActive("/question")
                          ? "bg-blue-500 text-white"
                          : "text-gray-500 hover:bg-blue-600 hover:text-white"
                      }`}
                    >
                      Ask Question
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>

          {/* These are the two icons for the cart and the user profile. */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginLeft: "auto",
              marginRight: "20px",
              maxWidth: "4rem",
            }}
          >
            {auth.isAuthenticated ? (
              <>
                <a
                  href="#"
                  className="header_widgets relative"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ion-icon
                    name="cart-outline"
                    className="is-icon"
                    style={{ fontSize: "1.5rem" }}
                  ></ion-icon>
                  <span className="absolute top-0 right-0 inline-flex items-center justify-center w-5 h-5 text-md font-semibold text-white bg-blue-600 rounded-full -mt-2 -mr-2">
                    {carts.length}
                  </span>
                </a>
                <div uk-drop="mode: click" className="dropdown_cart">
                  <div className="cart-headline">
                    My Cart{" "}
                    <a href="#/cart" className="checkout">
                      View All
                    </a>
                  </div>
                  {carts.length > 0 ? (
                    <ul className="dropdown_cart_scrollbar">
                      {carts.map((item) => (
                        <li key={item._id}>
                          <div className="cart_avatar">
                            <img
                              src={item.img}
                              alt=""
                              className="object-contain"
                            />
                          </div>
                          <div className="cart_text">
                            <h4>{truncate(item.name, 20)}</h4>
                            <p>
                              K{formatNumber(item.ori_price)} x {item.quantity}
                            </p>
                          </div>
                          <div className="cart_price">
                            <span>K{item.ori_price * item.quantity}</span>
                            <button
                              className="type"
                              onClick={() => removeItemCart(item._id)}
                            >
                              Remove
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-center p-5">
                      The cart is empty. You do not have any cart yet.
                    </p>
                  )}
                  <div className="cart_footer">
                    <h2>Total Items: {carts.length}</h2>
                    <h2>
                      <strong>Total: K{subtotal()}</strong>
                    </h2>
                  </div>
                </div>
              </>
            ) : null}
            {auth.isAuthenticated ? (
              <div>
                <a href="#">
                  <img
                    src="../assets/images/avatars/placeholder.png"
                    className="header_widgets_avatar"
                    alt=""
                  />
                </a>
                <div
                  uk-drop="mode: click;offset:5"
                  className="header_dropdown profile_dropdown"
                >
                  <ul>
                    <li>
                      <a href="#" className="user">
                        <div className="user_avatar">
                          <img
                            src="assets/images/avatars/placeholder.png"
                            alt=""
                          />
                        </div>
                        <div className="user_name">
                          <div>
                            {auth.user.firstName
                              ? `${auth.user.firstName} ${auth.user.lastName}`
                              : "No Name"}
                          </div>
                          <span>{auth.user.email}</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <hr />
                    </li>
                    <li>
                      <a href="#/order">
                        <ion-icon
                          name="bag-outline"
                          className="is-icon"
                        ></ion-icon>
                        Orders
                      </a>
                    </li>
                    <li>
                      <a href="#/account">
                        <ion-icon
                          name="settings-outline"
                          className="is-icon"
                        ></ion-icon>
                        Account Settings
                      </a>
                    </li>
                    <li>
                      <hr />
                    </li>
                    <li>
                      <Link to="#" onClick={onLogoutClick}>
                        <ion-icon
                          name="log-out-outline"
                          className="is-icon"
                        ></ion-icon>
                        Log Out
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <div className="hidden md:block lg: block">
                <Link
                  to="/login"
                  className="bg-blue-500 blue-500 px-6 py-3 rounded-md shadow text-white"
                >
                  Login
                </Link>
              </div>
            )}
          </div>

          {/* This is the menu icon on mobile */}
          <button
            className="bg-blue-500 blue-500 px-4 mr-4 py-0  rounded-md shadow text-white md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <ion-icon
              style={{ marginTop: "4px", fontSize: "1.8em" }}
              name="menu-outline"
              size="medium"
            ></ion-icon>
          </button>
        </div>
      </header>
      {/* Mobile Menu - only visible when open */}
      {isMobileMenuOpen && (
        <nav className="md:hidden fixed top-16 left-4 right-4 bg-white shadow-lg border rounded-md px-4 py-2 z-50">
          <ul className="space-y-2">
            <li>
              <Link
                onClick={closeMobileMenu}
                to="/"
                // to="/products"
                className={`w-full block border rounded-md text-center py-1 px-1 transition ${
                  isActive("/")
                    ? "bg-blue-500 text-white border-blue-500"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                STEM Kits
              </Link>
            </li>
            <li>
              <Link
                onClick={closeMobileMenu}
                to="/courses"
                className={`w-full block border rounded-md text-center py-1 px-1 transition ${
                  isActive("/courses")
                    ? "bg-blue-500 text-white border-blue-500"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                Courses
              </Link>
            </li>
            {/* <li>
              <Link
                onClick={closeMobileMenu}
                to="/books"
                className={`w-full block border rounded-md text-center py-1 px-1 transition ${
                  isActive("/books")
                    ? "bg-blue-500 text-white border-blue-500"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                Books
              </Link>
            </li> */}
            <li>
              <Link
                onClick={closeMobileMenu}
                to="/virtual"
                className={`w-full block border rounded-md text-center py-1 px-1 transition ${
                  isActive("/virtual")
                    ? "bg-blue-500 text-white border-blue-500"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                Virtual Labs
              </Link>
            </li>
            <li>
              <Link
                onClick={closeMobileMenu}
                to="/login"
                className={`w-full block border rounded-md text-center py-1 px-1 transition ${
                  isActive("/login")
                    ? "bg-blue-500 text-white border-blue-500"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                Login
              </Link>
            </li>

            {auth.isAuthenticated && (
              <li>
                <a href="#/question">Ask Question</a>
              </li>
            )}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Header;
